<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#3ea56e"
      size="128"
      is-full-screen
    />
    <v-snackbar v-model="showsnackbar" color="#3ea56e" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <div v-else class="add-product-page">
      <!-- Page Header -->
      <div class="page-header">
        <div class="page-title-group">
          <v-icon class="page-title-icon">mdi-store-edit</v-icon>
          <div>
            <h1 class="page-title">Edit Seller Profile</h1>
          </div>
        </div>
      </div>

      <!-- Form Body -->
      <div class="form-body">
        <v-form ref="profileForm" v-model="valid" lazy-validation>
          <v-row>
            <!-- LEFT COLUMN -->
            <v-col cols="12" lg="8" class="form-left-col">
              
              <!-- 01 Personal & Account Information -->
              <div class="form-section">
                <div class="section-header">
                  <span class="section-number">01</span>
                  <div>
                    <h2 class="section-title">Personal &amp; Account Information</h2>
                  </div>
                </div>
                <div class="section-body">
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">First Name</label>
                        <v-text-field
                          :rules="nameRules"
                          v-model="firstname"
                          color="#4CAF50"
                          outlined dense hide-details="auto"
                          placeholder="First Name"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">Last Name</label>
                        <v-text-field
                          :rules="nameRules"
                          v-model="lastname"
                          color="#4CAF50"
                          outlined dense hide-details="auto"
                          placeholder="Last Name"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">Owner Name</label>
                        <v-text-field
                          :rules="nameRules"
                          v-model="ownername"
                          color="#4CAF50"
                          outlined dense hide-details="auto"
                          placeholder="Owner Name"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">Username</label>
                        <v-text-field
                          :rules="nameRules"
                          v-model="username"
                          color="#4CAF50"
                          outlined dense hide-details="auto"
                          placeholder="Username"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">Account Type</label>
                        <v-text-field
                          v-model="accounttype"
                          color="#4CAF50"
                          outlined dense hide-details="auto"
                          placeholder="Account Type"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">Organization</label>
                        <v-text-field
                          v-model="organization"
                          color="#4CAF50"
                          outlined dense hide-details="auto"
                          placeholder="Organization"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <!-- 02 Contact & Location -->
              <div class="form-section">
                <div class="section-header">
                  <span class="section-number">02</span>
                  <div>
                    <h2 class="section-title">Contact &amp; Location</h2>
                  </div>
                </div>
                <div class="section-body">
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">Email</label>
                        <v-text-field
                          :rules="emailRules"
                          v-model="email"
                          color="#4CAF50"
                          outlined dense hide-details="auto"
                          placeholder="Email"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">Whatsapp Number</label>
                        <v-text-field
                          :rules="phoneRules"
                          v-model="phone"
                          color="#4CAF50"
                          outlined dense hide-details="auto"
                          placeholder="Whatsapp Number"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">Alternate Whatsapp</label>
                        <v-text-field
                          v-model="whatsapp"
                          color="#4CAF50"
                          outlined dense hide-details="auto"
                          placeholder="Alternate Whatsapp Number"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">Country</label>
                        <v-text-field
                          v-model="country"
                          color="#4CAF50"
                          outlined dense hide-details="auto"
                          placeholder="Country"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">District</label>
                        <v-text-field
                          v-model="district"
                          color="#4CAF50"
                          outlined dense hide-details="auto"
                          placeholder="District"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">Locality</label>
                        <v-text-field
                          v-model="locality"
                          color="#4CAF50"
                          outlined dense hide-details="auto"
                          placeholder="Locality"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">City</label>
                        <v-text-field
                          v-model="city"
                          color="#4CAF50"
                          outlined dense hide-details="auto"
                          placeholder="City"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">Street Address</label>
                        <v-text-field
                          v-model="streetAddress"
                          color="#4CAF50"
                          outlined dense hide-details="auto"
                          placeholder="Street Address"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">Pincode</label>
                        <v-text-field
                          :rules="pinRules"
                          v-model="pincode"
                          color="#4CAF50"
                          outlined dense hide-details="auto"
                          placeholder="Pincode"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <!-- 03 Bank & Tax Information -->
              <div class="form-section">
                <div class="section-header">
                  <span class="section-number">03</span>
                  <div>
                    <h2 class="section-title">Bank &amp; Tax Information</h2>
                  </div>
                </div>
                <div class="section-body">
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">Bank Name</label>
                        <v-text-field
                          v-model="bankname"
                          color="#4CAF50"
                          outlined dense hide-details="auto"
                          placeholder="Bank Name"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">Account Holder</label>
                        <v-text-field
                          v-model="accountholder"
                          color="#4CAF50"
                          outlined dense hide-details="auto"
                          placeholder="Account Holder"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">Account Number</label>
                        <v-text-field
                          v-model="accountnumber"
                          color="#4CAF50"
                          outlined dense hide-details="auto"
                          placeholder="Account Number"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">Branch</label>
                        <v-text-field
                          v-model="branch"
                          color="#4CAF50"
                          outlined dense hide-details="auto"
                          placeholder="Branch"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">IFSC Code</label>
                        <v-text-field
                          v-model="ifsccode"
                          color="#4CAF50"
                          outlined dense hide-details="auto"
                          placeholder="IFSC Code"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-group">
                        <label class="field-label">GST ID</label>
                        <v-text-field
                          v-model="gstid"
                          color="#4CAF50"
                          outlined dense hide-details="auto"
                          placeholder="GST ID"
                          class="modern-input"
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <!-- Submit (mobile / tablet only) -->
              <div class="submit-area-mobile hidden-lg-and-up">
                <v-row class="mt-2 pb-6">
                  <v-col cols="12" sm="6">
                    <v-btn block large depressed @click="$router.go(-1)" style="border-radius: 8px; border: 1px solid #dde3ea;">Cancel</v-btn>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-btn 
                      block large dark depressed 
                      color="#4CAF50" 
                      class="submit-btn text-capitalize" 
                      :ripple="false" 
                      :disabled="!valid"
                      @click="validate()">
                      <v-icon left>mdi-check-circle</v-icon>
                      Save Changes
                    </v-btn>
                  </v-col>
                </v-row>
              </div>

            </v-col>

            <!-- RIGHT COLUMN: Media Panel -->
            <v-col cols="12" lg="4" class="form-right-col">
              <div class="image-section sticky-panel">

                <!-- Profile Picture -->
                <div class="image-section-header">
                  <v-icon color="#4CAF50" class="mr-2">mdi-account-box</v-icon>
                  <span class="image-section-title">Profile Picture</span>
                </div>
                <div class="main-image-container">
                  <div class="main-image-wrapper">
                    <v-img
                      v-if="user.image && !imagePreview"
                      :src="mediaUURL + user.image"
                      height="200px"
                      contain
                      class="main-image"
                    ></v-img>
                    <v-img
                      v-else-if="imagePreview"
                      :src="imagePreview"
                      v-show="showPreview"
                      height="200px"
                      contain
                      class="main-image"
                    ></v-img>
                    <v-img
                      v-else
                      src="../../../assets/noimg.png"
                      height="200px"
                      contain
                      class="main-image"
                    >
                    </v-img>
                  </div>
                </div>
                <div class="mb-6">
                  <v-dialog v-model="changeImageDialog" max-width="800px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="#4CAF50" dark outlined block rounded v-on="on" v-bind="attrs" style="border-radius: 8px; font-family: poppinssemibold;">
                        <v-icon left>mdi-camera</v-icon>
                        Update Profile Picture
                      </v-btn>
                    </template>
                    <v-card>
                      <v-row class="py-5">
                        <v-col cols="12">
                          <ImageCropper
                            :singleImage="imagePreview"
                            @stepper="winStepper"
                            :height="'540'"
                            :width="'540'"
                            :heading="'Upload  Image (540 X 540)'"
                            :componentType="'image'"
                          />
                        </v-col>
                        <br />
                        <v-col class="text-center" cols="12">
                          <v-btn
                            :disabled="!file"
                            color="green"
                            @click="uploadImage"
                          >
                            <span style="color: white"> submit </span>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-dialog>
                </div>

                <!-- Cover Image -->
                <div class="image-section-header">
                  <v-icon color="#4CAF50" class="mr-2">mdi-panorama</v-icon>
                  <span class="image-section-title">Cover Image</span>
                </div>
                <div class="main-image-container">
                  <div class="main-image-wrapper">
                    <v-img
                      v-if="seller.coverimage && !coverPreview"
                      :src="mediaUURL + seller.coverimage"
                      height="120px"
                      contain
                      class="main-image"
                    ></v-img>
                    <v-img
                      v-else-if="coverPreview"
                      :src="coverPreview"
                      v-show="showcoverPreview"
                      height="120px"
                      contain
                      class="main-image"
                    ></v-img>
                    <v-img
                      v-else
                      src="../../../assets/noimg.png"
                      height="120px"
                      contain
                      class="main-image"
                    >
                      <div class="placeholder-overlay">
                        <v-icon color="#b0b8c8" size="40">mdi-image-plus</v-icon>
                        <p class="placeholder-text">No cover image</p>
                      </div>
                    </v-img>
                  </div>
                </div>
                <div class="mb-4">
                  <v-dialog
                    v-model="changeCoverImageDialog"
                    max-width="800px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="#4CAF50" dark outlined block rounded v-on="on" v-bind="attrs" style="border-radius: 8px; font-family: poppinssemibold;">
                        <v-icon left>mdi-panorama</v-icon>
                        Update Cover Image
                      </v-btn>
                    </template>
                    <v-card>
                      <v-row class="py-5">
                        <v-col cols="12">
                          <ImageCropper
                            :singleImage="coverPreview"
                            @stepper="winStepper"
                            :height="'600'"
                            :width="'2500'"
                            :heading="'Upload Cover Image (2500 X 600)'"
                            :componentType="'coverImage'"
                          />
                        </v-col>
                        <br />
                        <v-col class="text-center" cols="12">
                          <v-btn
                            :disabled="!coverFile"
                            color="green"
                            @click="uploadCover"
                          >
                            <span style="color: white"> submit </span>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-dialog>
                </div>

                <!-- Submit (desktop) -->
                <div class="hidden-md-and-down mt-6">
                  <v-btn 
                    block large dark depressed 
                    color="#4CAF50" 
                    class="submit-btn text-capitalize mb-2" 
                    :ripple="false" 
                    :disabled="!valid"
                    @click="validate()">
                    <v-icon left>mdi-check-circle</v-icon>
                    Save Changes
                  </v-btn>
                  <v-btn block large depressed @click="$router.go(-1)" style="border-radius: 8px; border: 1px solid #dde3ea;">Cancel</v-btn>
                </div>

              </div>
            </v-col>
          </v-row>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ImageCropper from "@/components/Common/singleImage";

export default {
  props: ["sellerid"],
  components: {
    ImageCropper,
  },
  data() {
    return {
      changeImageDialog: false,
      changeCoverImageDialog: false,
      ServerError: false,
      coverPreview: "",
      showPreview: false,
      showcoverPreview: false,
      bank: [],
      file: null,
      coverFile: null,
      image: "",
      coverimage: "",
      imagePreview: "",
      appLoading: false,
      showsnackbar: false,
      firstname: null,
      facebook: null,
      instagram: null,
      lastname: null,
      ownername: null,
      username: null,
      accounttype: null,
      country: null,
      phone: null,
      whatsapp: null,
      pincode: null,
      email: null,
      district: null,
      locality: null,
      city: null,
      organization: null,
      streetAddress: null,
      bankname: null,
      accountholder: null,
      accountnumber: null,
      branch: null,
      ifsccode: null,
      gstid: null,
      type: null,
      commisionPercentage: null,
      newProductsOrder: "",
      offersOrder: "",
      galleryOrder: "",
      msg: null,
      valid: true,
      user: [],
      seller: [],
      Rules: [(v) => !!v || "Required"],
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 15) || "Name must be less than 15 characters",
      ],
      emailRules: [
        (v) => !!v || "Email is Required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      phoneRules: [
        (v) => !!v || "Phone Number is Required",
        (v) => (v && v.length <= 10) || "Number must be less than 11",
        (v) => (v && v.length >= 10) || "Number must be grater than 10",
        (v) => /^\d{10}$/.test(v) || "Phone must be number",
      ],
      pinRules: [
        (v) => !!v || "Pincode is Required",
        (v) => /^(\d{4}|\d{6})$/.test(v) || "Pincode must be valid",
      ],
      gstRules: [
        (v) => !!v || "GSTID is Required",
        (v) =>
          /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(v) ||
          "GSTID must be valid",
      ],
      commisionPercentageRules: [
        // (v) => /^(\d{1}|\d{2}).(\d{1}|\d{2})$/.test(v) || "Pincode must be valid",
        (v) => !!v || " Commision Percentage is Required",
      ],
      ifscRules: [
        (v) => !!v || "IFSC Code is Required",
        (v) =>
          /[A-Z|a-z]{4}[0][a-zA-Z0-9]{6}$/.test(v || "IFSC Code must be valid"),
      ],
      accRules: [
        (v) => !!v || "Account Number is Required",
        (v) =>
          /^([0-9]{11})|([0-9]{2}-[0-9]{3}-[0-9]{6})$/.test(v) ||
          "Account Number must be valid",
      ],
    };
  },
  mounted: function() {
    this.getData();
  },
  methods: {
    winStepper(window_data) {
      if (window_data.type == "image") {
        this.file = window_data.selectedFiles;
      } else if (window_data.type == "coverImage") {
        this.coverFile = window_data.selectedFiles;
      }
    },
    validate() {
      if (this.$refs.profileForm.validate()) {
        this.editUser();
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/seller/info",
        method: "GET",
        params: {
          id: this.$route.query.seller,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.user = response.data.data;
          this.seller = this.user.seller;
          this.firstname = this.user.firstname;
          this.lastname = this.user.lastname;
          this.ownername = this.user.seller.ownername;
          this.username = this.user.username;
          this.phone = this.user.phone;
          this.email = this.user.email;
          this.district = this.user.district;
          this.pincode = this.user.pincode;
          this.locality = this.user.locality;
          this.city = this.user.city;
          this.organization = this.user.organization;
          this.streetAddress = this.user.streetAddress;
          this.whatsapp = this.user.whatsapp;
          this.facebook = this.seller.facebook;
          this.instagram = this.seller.instagram;
          this.type = this.user.type;
          this.accounttype = this.user.accounttype;
          this.country = this.user.country;
          this.bankname = this.user.seller.bankname;
          this.accountholder = this.user.seller.accountholder;
          this.accountnumber = this.user.seller.accountnumber;
          this.branch = this.user.seller.branch;
          this.gstid = this.user.seller.gstid;
          this.commisionPercentage = this.seller.commisionPercentage;
          this.ifsccode = this.user.seller.ifsccode;
          this.newProductsOrder = this.user.seller.newProductsOrder;
          this.offersOrder = this.user.seller.offersOrder;
          this.galleryOrder = this.user.seller.galleryOrder;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editUser() {
      this.appLoading = true;
      var user = {};
      user["firstname"] = this.firstname;
      user["lastname"] = this.lastname;
      user["ownername"] = this.ownername;
      user["username"] = this.username;
      user["phone"] = this.phone;
      user["email"] = this.email;
      user["type"] = this.type;
      user["accounttype"] = this.accounttype;
      user["country"] = this.country;
      user["streetAddress"] = this.streetAddress;
      user["pincode"] = this.pincode;
      user["locality"] = this.locality;
      user["district"] = this.district;
      user["city"] = this.city;
      user["organization"] = this.organization;
      user["whatsapp"] = this.whatsapp;
      user["facebook"] = this.facebook;
      user["instagram"] = this.instagram;
      user["bankname"] = this.bankname;
      user["accountholder"] = this.accountholder;
      user["accountnumber"] = this.accountnumber;
      user["branch"] = this.branch;
      user["gstid"] = this.gstid;
      // user["commisionPercentage"] = this.commisionPercentage;
      user["ifsccode"] = this.ifsccode;
      user["newProductsOrder"] = this.newProductsOrder;
      user["offersOrder"] = this.offersOrder;
      user["galleryOrder"] = this.galleryOrder;
      user["id"] = this.$route.query.seller;
      axios({
        method: "POST",
        url: "/user/AdminEdit",

        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: user,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            if (this.imagePreview) {
              this.uploadImage();
            } else if (this.coverPreview) {
              this.uploadCover();
            } else {
              this.getData();
              // this.uploadImage();
              this.$router.go(-1);
            }
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    showImage(e) {
      this.file = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.imagePreview = e.target.result;
      };
      if (this.file.size > 2145728) {
        this.msg = "File Should be less than 2MB";
        this.showsnackbar = true;
        return;
      }
      this.showPreview = true;
      //reader.readAsDataURL(files[0]);
      if (this.file) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
      }
    },
    showCover(e) {
      this.file = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.coverPreview = e.target.result;
      };
      if (this.file.size > 1145728) {
        this.msg = "File Should be less than 1MB";
        this.showsnackbar = true;
        return;
      }
      this.showcoverPreview = true;
      //reader.readAsDataURL(files[0]);
      if (this.file) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
      }
    },
    uploadImage() {
      let formData = new FormData();
      formData.append("photos", this.file);
      formData.append("id", this.$route.query.seller);
      axios({
        method: "POST",
        url: "/User/adminUploadImage",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.appLoading = false;

            this.changeImageDialog = false;
            this.showsnackbar = true;
            this.msg = "Uploaded Successfully";
            this.getData();

            // this.$router.go(-1);
          } else {
            this.appLoading = false;

            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    uploadCover() {
      let formData = new FormData();
      formData.append("id", this.$route.query.seller);
      formData.append("image", this.coverFile);

      axios({
        method: "POST",
        url: "/User/seller/UploadCoverImage",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.appLoading = false;

            this.changeCoverImageDialog = false;
            this.getData();
            this.showsnackbar = true;
            this.msg = "Uploaded Successfully";
            // this.$router.go(-1);
          } else {
            this.appLoading = false;

            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>
<style scoped>
/* ── Page Shell ─────────────────────────────── */
.add-product-page {
  min-height: 100vh;
  background: #f6f8fb;
}

/* ── Page Header ────────────────────────────── */
.page-header {
  background: #ffffff;
  border-bottom: 1px solid #e8ecf0;
  padding: 20px 28px;
  position: sticky;
  top: 0;
  z-index: 2;
}
.page-title-group {
  display: flex;
  align-items: center;
  gap: 14px;
}
.page-title-icon {
  font-size: 28px !important;
  color: #4caf50;
}
.page-title {
  font-family: poppinssemibold, sans-serif;
  font-size: 20px;
  color: #1c1c1c;
  margin: 0;
  line-height: 1.2;
}

/* ── Form Body ──────────────────────────────── */
.form-body {
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px 20px 48px;
}
.form-left-col {
  padding-right: 0;
}
@media (min-width: 1264px) {
  .form-left-col { padding-right: 20px; }
}

/* ── Section Cards ──────────────────────────── */
.form-section {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e8ecf0;
  margin-bottom: 20px;
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}
.form-section:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}
.section-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 24px;
  border-bottom: 1px solid #f0f3f7;
  background: #fafbfc;
}
.section-number {
  font-family: poppinssemibold, sans-serif;
  font-size: 22px;
  color: #d0d8e4;
  line-height: 1;
  min-width: 36px;
}
.section-title {
  font-family: poppinssemibold, sans-serif;
  font-size: 15px;
  color: #1c1c1c;
  margin: 0;
}
.section-body { padding: 20px 24px; }

/* ── Fields ─────────────────────────────────── */
.field-group { margin-bottom: 4px; }
.field-label {
  display: block;
  font-family: poppinssemibold, sans-serif;
  font-size: 12px;
  color: #555;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

/* ── Inputs ─────────────────────────────────── */
.modern-input >>> .v-input__slot {
  border-radius: 8px !important;
  min-height: 40px;
  background: #fdfdfd;
}
.modern-input >>> fieldset { border-color: #dde3ea !important; }
.modern-input:hover >>> fieldset { border-color: #4caf50 !important; }

/* ── Image Panel ────────────────────────────── */
.sticky-panel { position: sticky; top: 85px; }
.image-section {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e8ecf0;
  padding: 20px;
}
.image-section-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.image-section-title {
  font-family: poppinssemibold, sans-serif;
  font-size: 14px;
  color: #1c1c1c;
  flex: 1;
}
.main-image-container {
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e8ecf0;
  background: #f6f8fb;
  position: relative;
  margin-bottom: 12px;
}
.main-image-wrapper { position: relative; }
.main-image { border-radius: 10px; }
.placeholder-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.placeholder-text {
  font-family: poppinsregular, sans-serif;
  font-size: 13px;
  color: #b0b8c8;
  margin: 0;
}

/* ── Submit Button ──────────────────────────── */
.submit-btn {
  border-radius: 8px !important;
  font-family: poppinssemibold, sans-serif !important;
  font-size: 14px !important;
  letter-spacing: 0.5px;
  height: 48px !important;
  background: linear-gradient(135deg, #43a047, #66bb6a) !important;
  box-shadow: 0 4px 14px rgba(76, 175, 80, 0.35) !important;
  transition: box-shadow 0.2s ease, transform 0.15s ease !important;
}
.submit-btn:hover {
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.45) !important;
  transform: translateY(-1px);
}
.submit-area-mobile { margin-top: 8px; margin-bottom: 24px; }

/* ── Responsive ─────────────────────────────── */
@media (max-width: 960px) {
  .form-body { padding: 16px 12px 40px; }
  .section-header { padding: 14px 16px; }
  .section-body { padding: 14px 16px; }
  .page-header { padding: 14px 16px; }
}
@media (max-width: 600px) {
  .section-number { font-size: 16px; min-width: 28px; }
  .section-title { font-size: 14px; }
}
</style>
